<template>
  <div class="index-card">
    <tk-flex wrap :gutter="20" class="card-box">
      <!-- 循环体 -->
      <tk-flex
        middle
        :key="index"
        v-for="(item, index) in cardList"
        class="card-item bg-white border-radius-12"
      >
        <tk-flex middle center class="card-icon m-l-24 m-r-16">
          <tk-icon :size="20" :color="'#fff'">{{ item.icon }}</tk-icon>
        </tk-flex>
        <tk-flex column middle style="flexGrow: 1">
          <div class="font-14 wordBreak-lineHeight" >{{ item.title }}</div>
          <div class="font-24 font-bold m-t-5 wordBreak-lineHeight" >{{ item.num }}</div>
        </tk-flex>
      </tk-flex>
    </tk-flex>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      cardList: [
        {
          name: 'firstLevel',
          icon: 'warzone',
          title: '战区账号',
          num: 0
        },
        {
          name: 'secondLevel',
          icon: 'region',
          title: '大区账号',
          num: 0
        },
        {
          name: 'agent',
          icon: 'customer1',
          title: '代理商账号',
          num: 0
        },
        {
          name: 'store',
          icon: 'inventory1',
          title: '门店',
          num: 0
        },
        {
          name: 'clerk',
          icon: 'customer1',
          title: '业务员账号',
          num: 0
        },
        {
          name: 'mpuser',
          icon: 'minororder',
          title: '小程序用户',
          num: 0
        },
        {
          name: 'order',
          icon: 'Salesorder1',
          title: '商品订单量',
          num: 0
        },
        {
          name: 'sell',
          icon: 'aiappraisalorder1',
          title: '商品销售额',
          num: 0
        }
      ]
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      /// 根据用户等级判断首页显示数据
      let newArr = this.$tkHelper.deepClone(this.cardList)
      let level = this.user.level
      if (this.user.adminRole !== 'staff') {
        newArr.splice(4, 1)
      } else {
        // 从数组中按索引删除
        if (level === '1') { // 战区
          newArr.splice(0, 1)
          newArr.splice(3, 2)
        } else if (level === '2') { // 大区
          newArr.splice(0, 2)
          newArr.splice(2, 2)
        } else if (level === '3') { // 代理商
          newArr.splice(0, 3)
          newArr.splice(2, 1)
        } else if (level === '4') { // 业务员
          newArr.splice(0, 3)
          newArr.splice(1, 2)
        }
      }
      this.cardList = newArr
      // promise all 并发请求· 优化请求速度
      let arr = []
      for (let i = 0; i < this.cardList.length; i++) {
        arr.push(this.aggregateData(this.cardList[i].name))
      }
      await Promise.all(arr)
    },
    async aggregateData (name) {
      let where = {}
      let group = { objectId: '' }
      let className = '_User'
      switch (name) {
        case 'firstLevel':
          className = '_User'
          group.total = { $sum: 1 }
          where.isDelete = false
          where.level = '1'
          break
        case 'secondLevel':
          className = '_User'
          group.total = { $sum: 1 }
          where.isDelete = false
          where.level = '2'
          /// 一级下面的大区
          if (this.user.adminRole === 'staff') where.warZone = this.user.department
          break
        case 'agent':
          className = '_User'
          where.isDelete = false
          group.total = { $sum: 1 }
          where.level = '3'
          /// 二级下面的代理商
          if (this.user.adminRole === 'staff') {
            if (this.user.level === '1') where.warZone = this.user.department
            if (this.user.level === '2') where.regional = this.user.department
          }
          break
        case 'store':
          className = 'store'
          group.total = { $sum: 1 }
          where.isDelete = false
          /// 三级下面的代理商
          if (this.user.adminRole === 'staff') {
            if (this.user.level === '1') where.warZone = this.user.department
            if (this.user.level === '2') where.regional = this.user.department
            if (this.user.level === '3') {
              where.agency = this.user.department
              where.agent = this.user.objectId
            }
            if (this.user.level === '4') {
              where.salesmancy = this.user.department
              where.salesman = this.user.objectId
            }
          }
          break
        case 'clerk': // 只有代理可以看业务员
          className = '_User'
          group.total = { $sum: 1 }
          where.level = '4'
          where.agent = this.user.objectId
          break
        case 'mpuser': // 只有管理员可以看小程序用户
          className = '_User'
          group.total = { $sum: 1 }
          where.userRole = { $in: ['user', 'store'] }
          break
        case 'order': // 只统计已完成 所有用户都可以看
          className = 'order'
          group.total = { $sum: 1 }
          where.status = '2'
          /// 对应部门下面的订单量
          if (this.user.adminRole === 'staff') {
            if (this.user.level === '1') where.warZone = this.user.department
            if (this.user.level === '2') where.regional = this.user.department
            if (this.user.level === '3') {
              where.agency = this.user.department
              where.agent = this.user.objectId
            }
            if (this.user.level === '4') {
              where.salesmancy = this.user.department
              where.salesman = this.user.objectId
            }
          }
          break
        case 'sell': // 只统计已完成  所有用户都可以看
          className = 'order'
          group.total = { $sum: '$orderAmount' }
          where.status = '2'
          /// 对应部门下面的销售额
          if (this.user.adminRole === 'staff') {
            if (this.user.level === '1') where.warZone = this.user.department
            if (this.user.level === '2') where.regional = this.user.department
            if (this.user.level === '3') {
              where.agency = this.user.department
              where.agent = this.user.objectId
            }
            if (this.user.level === '4') {
              where.salesmancy = this.user.department
              where.salesman = this.user.objectId
            }
          }
          break
      }
      let { data: res } = await this.$tkParse.get(`/aggregate/${className}`, {
        params: {
          group: group,
          match: where
        }
      })
      let int = this.cardList.findIndex(item => item.name === name)
      this.cardList[int].num = res.results && res.results.length ? res.results[0].total || 0 : 0
    }
  }
}
</script>
<style scoped lang="scss">
.card-icon {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background-color: #f6313f;
  flex-shrink: 0;
}
.card-item {
  min-width: 300px;
  height: 106px;
  flex: 1;
  box-sizing: border-box;
}
.wordBreak-lineHeight{
  word-break: break-all;
  line-height: 1;
}
</style>
